import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ImageTransform, ImageCroppedEvent, Dimensions, ImageCropperComponent, LoadedImage } from 'ngx-image-cropper';
import { UploadService } from 'src/app/shared/services/upload.service';
import { environment } from 'src/environments/environment';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpResponseState } from 'src/app/core/modals/response-type';
import { Image } from 'src/app/modules/catalog/product/store/variant.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';


class ImageSnippet {
  constructor(public src: string, public file: File) { }
}

@Component({
    selector: 'app-image-upload',
    templateUrl: './image-upload.component.html',
    styleUrls: ['./image-upload.component.scss'],
    standalone: false
})

export class ImageUploadComponent implements OnInit {
  @Input() data: Image;
  subscribe: Subscription = new Subscription();
  public selectedFile = new BehaviorSubject<string>('');
  imagePath: any = null;
  defaultImage: boolean = true;
  image: any = null;
  environment: any = environment;
  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl  = '';
  // imageChangedEvent: any = '';
  // croppedImage: any = '';
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = true;
  transform: ImageTransform = {};

  selectFile: File;
  // selectedFileNames: string[] = [];

  uploadProgress: number = 0;
  errors: Array<any> = [];

  previews: string[] = [];
  imageInfos?: Observable<any>;
  uploadCropedImage: any;
  File: ImageSnippet;
  uploadFileId: number;
  uploadedFilePath: string | null = null;

  @Output() images = new EventEmitter<any>();
  // @Output() images1 = new EventEmitter<any>();
  // @Output() images2 = new EventEmitter<any>();

  constructor(
    @Optional() private readonly activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private fileUpload: UploadService,
    private sanitizer: DomSanitizer
    
  ) {

  }
  ngOnInit(): void {
    if (this.data != undefined) {
      this.uploadProgress = 100;
      this.defaultImage = false;
      this.uploadedFilePath = environment.mediaUrl + this.data.path;
    }
  }


  processFile(imageInput: any, event) {
    const file: File = imageInput.files[0];
    this.selectFile = file;
    this.upload(file);
    this.imageChangedEvent = event;
    const reader = new FileReader();
    reader.addEventListener('load', (e: any) => {
      this.defaultImage = false;
      this.File = new ImageSnippet(e.target.result, file);
    });

    reader.readAsDataURL(file);
  }

  async upload(file: File) {

    let resp: any;

    if (!file) {
      this.errors.push('Please select a file to upload.');
      return this.errors;
    }

    try {
      const response: any = await (
        this.fileUpload.mediaCreate(file) // Or direct HTTP request
      ).toPromise();

      if (response.ok && response.status === 201) {
        this.uploadProgress = 100;
        resp = response.body?.result; // Extract data from response
        this.defaultImage = false;
        this.uploadedFilePath = environment.mediaUrl + resp.filepath;
        this.uploadFileId = resp.fileid;
        this.images.emit({ id: resp.fileid, path: resp.filepath });
        console.log('Image uploaded successfully!', resp);
      } else {
        throw new Error('Upload failed with status: ' + response.status);
      }
    } catch (error) {
      this.uploadProgress = 0;
      this.errors.push('Upload failed: ' + error.message);
      console.error('Upload error:', error);
    }
  }

  remove(event) {
    this.uploadedFilePath = null;
    this.defaultImage = true;
    this.selectedFile.next(null);
    this.delete(this.uploadFileId);
  }

  async delete(id: number) {
    console.log(id);
    const postData = {
      id: id,
    };
    const deleteMedia = this.fileUpload.delete(postData).subscribe((res: HttpResponseState) => {

    }
    );
    this.subscribe.add(deleteMedia);
  }

  crop(event, content) {
    console.log(event);
    this.showCropper = true;
    this.imageChangedEvent = event;
    this.modalService.open(content, { size: 'lg' });
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
    this.uploadCropedImage = event;
  }

  imageLoaded(image: LoadedImage) {
    console.log(image);
    this.showCropper = true;
    console.log('Image loaded')
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
  }

  loadImageFailed() {
    console.log('Load Failed');
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }

  uploadImageCrop() {
    console.log(this.uploadCropedImage);
    // const formData: FormData = new FormData();
    // formData.append('file', this.selectFile, this.selectFile.name);

    const postData ={
      id: this.uploadFileId,
      height: this.uploadCropedImage.height,
      width: this.uploadCropedImage.width,
      croped_position: this.uploadCropedImage.cropperPosition
    }

    // const postData = [{
    //   key: 'id',
    //   value: this.uploadFileId,
    // },
    // {
    //   key: 'file',
    //   value: formData,
    // },
    // {
    //   key: 'url',
    //   value: this.uploadedFilePath,
    // },
    // {
    //   key: 'width',
    //   value: this.uploadCropedImage.width,
    // },
    // {
    //   key: 'height',
    //   value: this.uploadCropedImage.height,
    // }]
    const cropMedia = this.fileUpload.imageCrop(postData).subscribe((res: any) => {
      console.log(res);
      this.uploadedFilePath = environment.mediaUrl + res.result
    }
    );
    this.subscribe.add(cropMedia);
  }

  saveClick() {
    this.uploadImageCrop()
  }

  cancel() {

  }

}
